export const LogoMark = ({ size = 30, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" className={className} aria-hidden="true">
    <rect width="32" height="32" rx="7" fill="#09090B" />
    <rect x="6" y="12" width="3" height="8" rx="1.5" fill="#FAF9F6" />
    <rect x="11.5" y="7" width="3" height="18" rx="1.5" fill="#2563EB" />
    <rect x="17" y="10" width="3" height="12" rx="1.5" fill="#FAF9F6" />
    <rect x="22.5" y="13" width="3" height="6" rx="1.5" fill="#FAF9F6" />
  </svg>
);
